import script from "./CompanyListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyListCard.vue?vue&type=script&setup=true&lang=js"

import "./CompanyListCard.vue?vue&type=style&index=0&id=bcb25d72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcb25d72"]])

export default __exports__